import React, { useEffect, useState, useContext } from "react";
import EquipmentImageWithLoader from "./EquipmentImageWithLoader";
import { getEquipmentBrand } from "../../../../api";
import config from "../../../../config";
import { FaCheck } from "react-icons/fa";
import Equipment from "./Equipment";
import { EquipmentContext } from "../useContext/context";
import { Button } from "@mui/material";
import { FaPlusCircle } from "react-icons/fa";

const URL = config.paymentcloud.STRATUS_URL;

export default function BrandSelection({
    allEquipments,
    updateSelectedEquipments,
    org_id,
}) {
    const [brands, setBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);

    const [expandedDevice, setExpandedDevice] = useState({});
    const { isDeviceExpanded, setIsDeviceExpanded, categories_selected } =
        useContext(EquipmentContext);

    useEffect(() => {
        getEquipmentBrand({
            all: "all",
            org_id: org_id,
        }).then((res) => {
            setBrands(res.data);
        });
    }, []);

    const onSelectBrand = (brand) => {
        if (selectedBrand == null) {
            setSelectedBrand(brand);
        }
        if (selectedBrand?.id == brand.id) {
            setSelectedBrand(null);
        }
    };

    const onSelectedModel = (equipment) => {
        setExpandedDevice(equipment);
        setIsDeviceExpanded(true);
    };

    const renderBrands = () => {
        return brands.map((brand) => (
            <>
                {brand?.equipments?.length > 0 ? (
                    <div
                        className="eqp-col"
                        tabIndex="0"
                        role="button"
                        key={brand.id}
                    >
                        <div className={`equipment-item`}>
                            <div
                                className={`eqp-img`}
                                onClick={() => onSelectBrand(brand)}
                            >
                                {brand.id == selectedBrand?.id && (
                                    <div className="eqp-img-overlay">
                                        <div className="eqp-selected">
                                            <FaCheck />
                                        </div>
                                    </div>
                                )}
                                <EquipmentImageWithLoader
                                    id={1}
                                    src={`${URL}get-image-by-path?path=${brand.image}`}
                                />
                            </div>
                            <div className="eqp-info">
                                <p className="eqp-name">{brand.name}</p>
                            </div>
                            {brand.id == selectedBrand?.id && (
                                <div class="input-wrapper">
                                    <label htmlFor={"new"}>{"Models"}</label>
                                    <select
                                        name={"new"}
                                        id={"new"}
                                        onChange={(e) =>
                                            onSelectedModel(
                                                brand?.equipments[
                                                    e.target.value
                                                ],
                                            )
                                        }
                                    >
                                        <option value="">Select</option>
                                        {brand?.equipments?.map(
                                            (equipment, index) => (
                                                <option
                                                    key={index}
                                                    value={index}
                                                >
                                                    {equipment.equipment_name}
                                                </option>
                                            ),
                                        )}
                                    </select>
                                </div>
                            )}
                        </div>
                    </div>
                ) : null}
            </>
        ));
    };

    const handleInputChange = (name, value) => {
        const { type } = expandedDevice;
        const newState = {
            ...expandedDevice,
            [name]: value,
        };

        setExpandedDevice(newState);

        const { equipment_slug: slug } = newState;

        updateSelectedEquipments((prevState) => {
            const purchaseType = prevState[type] || {};
            const equipments = purchaseType[slug] || [];
            equipments[equipments.length - 1] = newState;

            return {
                ...prevState,
                [type]: {
                    ...purchaseType,
                    [slug]: [...equipments],
                },
            };
        });
    };

    const handlePurchaseTypeChanged = (event, type) => {
        event.persist();
        const { type: prevType } = expandedDevice;
        const newState = {
            ...expandedDevice,
            type,
        };
        setExpandedDevice(newState);

        const { equipment_slug: slug } = newState;

        if (prevType) {
            updateSelectedEquipments((prevState) => {
                const purchaseType = prevState[type] || {};
                const equipments = purchaseType[slug] || [];

                const prevPurchaseType = prevState[prevType] || {};
                const prevEquipments = prevPurchaseType[slug] || [];

                return {
                    ...prevState,
                    [prevType]: {
                        ...prevPurchaseType,
                        [slug]: prevEquipments.slice(0, -1),
                    },
                    [type]: {
                        ...purchaseType,
                        [slug]: [...equipments, newState],
                    },
                };
            });
        } else {
            updateSelectedEquipments((prevState) => {
                const purchaseType = prevState[type] || {};
                const equipments = purchaseType[slug] || [];

                return {
                    ...prevState,
                    [type]: {
                        ...purchaseType,
                        [slug]: [...equipments, newState],
                    },
                };
            });
        }
    };

    const onResetSelectedDevice = () => {
        setExpandedDevice({});
        setIsDeviceExpanded(false);
        setSelectedBrand(null);
    };

    const renderActionBtn = () => {
        return (
            <Button
                startIcon={<FaPlusCircle className="add-devices-icon" />}
                className="add-device-btn"
                onClick={onResetSelectedDevice}
            >
                Add add'l devices
            </Button>
        );
    };

    return (
        <>
            <div className="equipments-section mt-2r">
                <h6 className="sub-heading">Mobile Systems & Terminals</h6>
                <div>
                    <div className="equipment-box">
                        <div className="eqp-row">
                            {expandedDevice?.id ? (
                                <Equipment
                                    key={expandedDevice.id}
                                    equipment={expandedDevice}
                                    handleInputChange={handleInputChange}
                                    handleTypeCheck={handlePurchaseTypeChanged}
                                    allEquipments={allEquipments}
                                    onDeselectEquipment={onResetSelectedDevice}
                                    renderActionBtn={renderActionBtn}
                                />
                            ) : (
                                renderBrands()
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
